export const selectUserGallerySlug = state => state.user.user.slug;
export const selectUser = state => state.user.user;
